<template>
  <a-popover
    v-model:open="visible"
    trigger="click"
    :placement="placement"
    :overlay-class-name="overlayClassName"
    :get-popup-container="getPopupContainer"
    @open-change="handleVisibleChange"
  >
    <template #content>
      <div class="flex flex-col min-w-[220px] max-w-[320px] proxima_nova">
        <div class="max-h-[300px] overflow-y-auto p-1">
          <template v-if="grouped && groups.length > 1">
            <div
              v-for="(group, groupIndex) in groups"
              :key="`${group.id}_group_${groupIndex}`"
            >
              <div
                v-if="group.category"
                class="px-3 py-2 text-[11px] font-semibold uppercase opacity-60 primary_color"
              >
                {{ group.category.label }}
              </div>

              <div
                v-for="(option, index) in group.operators"
                :key="`${groupIndex}_${option.value}_${index}`"
                class="!pl-8 !pr-3 !py-2 !text-sm dropdown_item"
                @click.stop="handleItemClick(option.value)"
              >
                {{ option.label }}
              </div>
            </div>
          </template>

          <template v-else>
            <div
              v-for="(option, index) in options"
              :key="`${option.value}_option_${index}`"
              class="dropdown_item"
              @click.stop="handleItemClick(option.value)"
            >
              {{ option.label }}
            </div>
          </template>

          <div
            v-if="options.length === 0 && (!grouped || groups.length === 0)"
            class="p-3 text-center secondary_color text-sm"
          >
            {{ emptyMessage }}
          </div>
        </div>
      </div>
    </template>
    <slot :is-open="visible" />
  </a-popover>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  emptyMessage: { type: String, default: "No options found" },
  options: { type: Array, default: () => [] },
  placement: { type: String, default: "bottom" },
  overlayClassName: { type: String, default: "" },
  grouped: { type: Boolean, default: false },
  groups: { type: Array, default: () => [] },
});

const emit = defineEmits(["select", "visible-change"]);

const visible = ref(false);

const getPopupContainer = (trigger) => {
  try {
    if (typeof document !== "undefined" && document.body) {
      return document.body;
    }
    return trigger || null;
  } catch (error) {
    console.error("An error occurred while getting popup container: ", error);
    return null;
  }
};

const handleVisibleChange = (isVisible) => {
  try {
    emit("visible-change", isVisible);
  } catch (error) {
    console.error("An error occurred while handling visible change: ", error);
  }
};

const handleItemClick = (value) => {
  try {
    visible.value = false;
    emit("select", value);
  } catch (error) {
    console.error(
      "[SearchablePopoverSelector] Error in handleItemClick:",
      error,
    );
  }
};
</script>
